<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"FACILITATOR.important" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold "><span>{{"FACILITATOR.important-text" | translate | slice:0:5 }}{{data.action}}</span>
  <span>{{"FACILITATOR.important-text" | translate | slice:15:90 }}</span>
  </p>

  <div class="btn-proceed alt-flex-end">
    <button class="btn-agree alt-color-bran1 pointer alt-size-14 alt-inter-medium" type="button" [mat-dialog-close]="true">{{"AUTH.confirm"
      | translate
      }}</button>
  </div>
</div>
